"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_ROOT = exports.GITHUB_ROOT = void 0;
var tslib_1 = require("tslib");
require("./style.scss");
require("./favicon.ico");
var mithril_1 = tslib_1.__importDefault(require("mithril"));
var Main_1 = tslib_1.__importDefault(require("./components/Main"));
var normalizeDocs_1 = require("./utils/normalizeDocs");
var docs = (0, normalizeDocs_1.normalizeDocs)(require('../generated/docs.json'));
exports.GITHUB_ROOT = 'https://github.com/vasilrimar/construct-ui';
exports.DEFAULT_ROOT = '/introduction/getting-started';
mithril_1.default.route.prefix = '#';
var resolveRoute = function (wrapper) { return ({
    onmatch: function (attrs, requestedPath) {
        attrs.docs = docs;
        attrs.requestedPath = requestedPath;
        window.requestAnimationFrame(function () { return window.scrollTo(0, 0); });
    },
    render: function (_a) {
        var attrs = _a.attrs;
        return (0, mithril_1.default)(wrapper, tslib_1.__assign({}, attrs));
    }
}); };
var initRoutes = function (layout) {
    mithril_1.default.route(document.getElementById('Docs'), exports.DEFAULT_ROOT, {
        '/introduction/:page': resolveRoute(layout),
        '/components/:page...': resolveRoute(layout),
        '/utils/:page...': resolveRoute(layout)
    });
};
initRoutes(Main_1.default);
if (module.hot) {
    module.hot.accept('./components/Main', function () {
        var main = require('./components/Main').default;
        initRoutes(main);
    });
}
